<template>
  <div class="patient-info">
    <div class="patient-title">
      <span class="title">关联病历</span>
      <span class="connect">
        <span>更多</span>
        <i class="el-icon-arrow-right"/>
      </span>
    </div>
    <div class="patient-row">
      <div>
        <span class="key">过敏史:</span>
        <span class="value">{{ connectData["allergy"].join("，") }}</span>
      </div>
    </div>
    <div class="patient-row">
      <div class="latest">
        <span class="key">最新就诊记录：</span>
        <div>
          <span
            v-for="item in connectData['latest']"
            :key="item"
            class="value"
          >
            {{ item }} <br>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PatientInfo",
  props: {
    connectData: {
      type: Object,
      default() {
        return {};
      }
    }
  }
};
</script>

<style scoped lang="scss">
.patient-info {
  margin-bottom: 60px;
}

.patient-title {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.patient-row {
  display: flex;
  justify-content: space-between;
  width: 590px;
  margin: 15px 0;
  align-items: center;

  .latest {
    display: flex;
  }

  .key {
    font-size: 16px;
    color: #666666;
    min-width: 142px;
    display: inline-block;
  }

  .value {
    font-size: 16px;
    color: #333333;
  }
}

</style>
